var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.66667C4 9.2795 4.12071 9.88634 4.35523 10.4525C4.58975 11.0187 4.93349 11.5332 5.36683 11.9665C5.80017 12.3998 6.31462 12.7436 6.88081 12.9781C7.447 13.2126 8.05383 13.3333 8.66667 13.3333C9.2795 13.3333 9.88634 13.2126 10.4525 12.9781C11.0187 12.7436 11.5332 12.3998 11.9665 11.9665C12.3998 11.5332 12.7436 11.0187 12.9781 10.4525C13.2126 9.88634 13.3333 9.2795 13.3333 8.66667C13.3333 8.05383 13.2126 7.447 12.9781 6.88081C12.7436 6.31462 12.3998 5.80017 11.9665 5.36683C11.5332 4.93349 11.0187 4.58975 10.4525 4.35523C9.88634 4.12071 9.2795 4 8.66667 4C8.05383 4 7.447 4.12071 6.88081 4.35523C6.31462 4.58975 5.80017 4.93349 5.36683 5.36683C4.93349 5.80017 4.58975 6.31462 4.35523 6.88081C4.12071 7.447 4 8.05383 4 8.66667Z",
    stroke: "#686F7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L12 12",
    stroke: "#686F7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fc6c732463116b59974f020fb0fca3e8.svg";
export { ForwardRef as ReactComponent };